import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';
import { IUser } from '../hooks/check-auth';

interface SignInParams {
  username: string;
  password: string;
};

interface SignInResponse {
  data: {
    access_token: string;
    user: IUser;
  };
};

interface VerifyOTPParams {
  email: string;
  otp: string;
};

interface VerifyOTPResponse {
  data: {
    token: string;
    user: IUser;
  };
};

interface ForgotPasswordParams {
  email: string;
};

interface ForgotPasswordResponse {
  data: {
    message: string;
  };
};

interface ResetPasswordParams {
  password: string;
};

interface ResetPasswordResponse {
  data: {
    message?: string;
  };
};

class AuthenticationAPI {
  async signIn(params: SignInParams): Promise<SignInResponse> {
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: '/api/auth/login',
      data: params,
    });
    
    localStorage.setItem('access-token', res.data.data.access_token)
    return res.data
  };

  async verifyOTP(params: VerifyOTPParams): Promise<VerifyOTPResponse> {
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: '/api/verify-otp',
      data: params,
    })
    localStorage.setItem('access-token', res.data.data.token)
    return res.data
  }

  async forgotPassword(params: ForgotPasswordParams): Promise<ForgotPasswordResponse> {
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: '/api/auth/forgotpassword',
      data: params,
    })
    return res.data
  }

  async resetPassword(userId: string, params: ResetPasswordParams): Promise<ResetPasswordResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/auth/resetPassword/${userId}`,
      data: params,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  }

  async signOut() {
    localStorage.removeItem('access-token');
    localStorage.removeItem('loggedInUser');
    // const res: AxiosResponse = await makeAPIRequest({
    //   method: 'POST',
    //   url: '/api/v1/auth/logout',
    // })
    // return res.data
  }
}

// TODO: Fix ESLint anonymous default export - assign instance to variable before exporting
// Current: export default new AuthenticationAPI()
// Should be: const authenticationAPI = new AuthenticationAPI(); export default authenticationAPI;
const authenticationApi = new AuthenticationAPI() 
export default authenticationApi;
